// import { createApp } from 'vue';
import { createWebHistory, createRouter } from "vue-router";
import { Cookie } from '@/utils';

import routes from './routes';

export const router = createRouter({
    history: createWebHistory(),
    root: '/',
    routes,
});

// export const router = new Router({
//     mode: 'history',
//     transitionOnLoad: true,
//     // linkActiveClass: 'active',
//     linkExactActiveClass: 'mm-active',
//     root: '/',
//     routes,
// });

router.beforeEach((to, from, next) =>
{
    const notAuthRequired = ['signin', 'forgot-password', 'activation', 'reset-password', 'validate-code'];
	const authRequired = !notAuthRequired.includes(to.meta.page);

    const hasAccessToken = Cookie.get(process.env.VUE_APP_ACCESS_TOKEN_STORAGE) !== null;

    // if (hasAccessToken && to.path === '/') return next('/dashboard');

    if(authRequired && !hasAccessToken) return next('/signin');

	if(!authRequired && hasAccessToken) return next('/');

	if(to.path == '/') return next('/welcome');

    return next();
});
